import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    subject: '',
    content_area: '',
    domain: '',
    complexity: '',
  },
  goalbankSelection: {},
  curriculumSelection: {}
}

export const goalbankUI = createSlice({
  name: 'goalbankUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setContentArea: (state, { payload }) => {
      state.tableFilters.content_area = payload
    },
    setDomain: (state, { payload }) => {
      state.tableFilters.domain = payload
    },
    setComplexity: (state, { payload }) => {
      state.tableFilters.complexity = payload
    },
    setGoalbankSelection: (state, { payload }) => {
      state.goalbankSelection = payload
    },
    setCurriculumSelection: (state, { payload }) => {
      state.curriculumSelection = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setSubject,
  setContentArea,
  setDomain,
  setComplexity,
  setGoalbankSelection,
  setCurriculumSelection,
  trackActiveFilters,
  clearAllFilters,
} = goalbankUI.actions

export default goalbankUI.reducer
